import { render, staticRenderFns } from "./ProductManage.vue?vue&type=template&id=f1095b78&"
import script from "./ProductManage.vue?vue&type=script&lang=ts&"
export * from "./ProductManage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports